import Avatar from '@components/common/Avatar';
import { cn } from '@utils/cn';

export interface UserTileProps {
  name: string;
  plan: string;
  collapsed?: boolean;
}

export default function UserTile({ name, plan, collapsed }: UserTileProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2.5 overflow-hidden rounded-[10px] border border-line bg-surface-2 p-2.5',
        collapsed && 'justify-center px-2',
      )}
    >
      <Avatar name={name} size="sm" bordered={false} />
      {collapsed ? null : (
        <div className="min-w-0 flex-1 overflow-hidden">
          <div className="truncate text-[13px] font-semibold text-t1">{name}</div>
          <div className="mt-[1px] text-[10px] font-bold uppercase tracking-[0.08em] text-gold">
            {plan}
          </div>
        </div>
      )}
    </div>
  );
}
